'use client';

import { GitCompare, Heart, ShoppingBag, ShoppingCart, User } from 'lucide-react';
import { useRef } from 'react';

import { clsx } from 'clsx';

import { ICON_ONDARK } from '@shared/constants/colors';
import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { useClickMenuItem } from '@shared/hooks/useClickMenuItem';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';
import { addPadding, removePadding } from '@shared/utils/scrollHelpers/scrollHelpers';

import { CategoriesMobile, closeCategoriesModal, openCategoriesModal } from '../../CategoriesMenu';
import cls from './BottomMenu.module.scss';

export const BottomMenu = () => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const dispatch = useAppDispatch();

  const viewPort = useAppSelector(getViewPort);
  const openModal = useAppSelector((state) => state.categoriesModal.open);
  const favoriteProducts = useAppSelector((state) => state.favorites.productIds);
  const comparison = useAppSelector((state) => state.comparison.productIds);
  const cartProducts = useAppSelector((state) => state.cart.productIds);

  const onClickHandler = useClickMenuItem();

  const toggleModal = () => {
    if (openModal) {
      dispatch(closeCategoriesModal());
      removePadding();
    } else {
      dispatch(openCategoriesModal());
      addPadding();
    }
  };

  return (
    <div
      data-testid="bottom-menu"
      className={clsx(cls.wrap)}
      data-style={'padding-lock'}
    >
      <div className={cls.inner}>
        <button
          className={cls.item}
          onClick={() => onClickHandler(ROUTES.PERSONAL_ACCOUNT)}
        >
          <User color={ICON_ONDARK} />
          <span className={cls.label}>Профиль</span>
        </button>
        <button
          className={cls.item}
          onClick={() => onClickHandler(ROUTES.CART)}
        >
          <div className={cls.icon}>
            <ShoppingCart color={ICON_ONDARK} />
            {!!cartProducts.length && <div className={cls.quantity}>{cartProducts.length}</div>}
          </div>

          <span className={cls.label}>Корзина</span>
        </button>
        <button
          ref={buttonRef}
          data-testid={'mobile-catalog-btn'}
          className={cls.item}
          onClick={toggleModal}
        >
          <ShoppingBag color={ICON_ONDARK} />
          <span className={cls.label}>Каталог</span>
        </button>
        <button
          className={cls.item}
          onClick={() => onClickHandler(ROUTES.FAVORITES)}
        >
          <div className={cls.icon}>
            <Heart color={ICON_ONDARK} />
            {favoriteProducts.length > 0 && <div className={cls.quantity}>{favoriteProducts.length}</div>}
          </div>
          <span className={cls.label}>Избранное</span>
        </button>
        <button
          className={cls.item}
          onClick={() => onClickHandler(ROUTES.COMPARISON)}
        >
          <div className={cls.icon}>
            <GitCompare color={ICON_ONDARK} />
            {comparison.length > 0 && <div className={cls.quantity}>{comparison.length}</div>}
          </div>
          <span className={cls.label}>Сравнение</span>
        </button>
      </div>

      {viewPort !== 'desktop' && openModal && <CategoriesMobile buttonRef={buttonRef} />}
    </div>
  );
};
